export default __webpack_public_path__ + "static/media/3.489f555a.png";